// Core
import { call, put } from 'redux-saga/effects';
import { Map } from 'immutable';
import moment from 'moment';

// Instruments
import { historyActions as actions } from 'bus/history/actions';
import { historyStorage as storage } from 'bus/history/storage';

export function* addViewedHotelWorker ({ payload: { hotel, offer }}) {
    try {
        const { id: hotelId } = hotel;
        const { id: offerId } = offer;

        yield call([storage, 'set'], hotelId, {
            hotel:   Map(hotel).set('offers', [offerId]).toJS(),
            offer,
            expires: moment().add(1, 'day').format(),
        });
        yield put(actions.addViewedHotelSuccess(hotelId, offerId));
    } catch (error) {
        yield put(actions.addViewedHotelFail(error));
    }
}
